import "bootstrap/dist/css/bootstrap.min.css";
import "react-phone-input-2/lib/style.css";

import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { Toaster } from "sonner";

import Routes from "./routes";
import { store } from "./store";
import { Layout } from "Layout";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <StrictMode>
    <Provider store={store}>
      <Layout>
        <Routes />
      </Layout>
    </Provider>
    <Toaster position="top-right" richColors />
  </StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
